// extracted by mini-css-extract-plugin
export default {"songsResults":"SongsResultsBrowse_songsResults__Yegvk","desktop":"SongsResultsBrowse_desktop__muVD5","songsTally":"SongsResultsBrowse_songsTally__kgF9F"};